import React, { useEffect, useState } from "react";
import "./personality.css";

// 🖼️ Posters
import emile from "../../movies/melomana/8mile.jpg";
import acrosstheuniverse from "../../movies/melomana/acrosstheuniverse.jpg";
import betterman from "../../movies/melomana/betterman.jpg";
import hedwigandtheangryinch from "../../movies/melomana/hedwigandtheangryinch.jpg";
import lalaland from "../../movies/melomana/lalaland.jpg";
import rocketman from "../../movies/melomana/rocketman.jpg";
import schoolofrock from "../../movies/melomana/schoolofrock.jpg";
import tar from "../../movies/melomana/tar.jpg";
import thegreatestshowman from "../../movies/melomana/thegreatestshowman.jpg";
import whiplash from "../../movies/melomana/whiplash.jpg";

// 🎬 Datos reales
const movies = [
  {
    title: "8 Mile",
    image: emile,
    director: "Curtis Hanson",
    year: 2002,
    cast: "Eminem, Kim Basinger, Brittany Murphy",
    synopsis: "Un joven rapero lucha por hacerse un lugar en la escena del hip-hop de Detroit."
  },
  {
    title: "Across the Universe",
    image: acrosstheuniverse,
    director: "Julie Taymor",
    year: 2007,
    cast: "Evan Rachel Wood, Jim Sturgess",
    synopsis: "Un romance musical ambientado en la década de los 60 con canciones de The Beatles."
  },
  {
    title: "Betterman",
    image: betterman,
    director: "Yasuhiro Yoshiura",
    year: 2002,
    cast: "Varios actores (anime)",
    synopsis: "Una historia animada sobre identidad, humanidad y tecnología."
  },
  {
    title: "Hedwig and the Angry Inch",
    image: hedwigandtheangryinch,
    director: "John Cameron Mitchell",
    year: 2001,
    cast: "John Cameron Mitchell, Miriam Shor",
    synopsis: "Un cantante transgénero de rock viaja con su banda mientras narra su vida y transformaciones."
  },
  {
    title: "La La Land",
    image: lalaland,
    director: "Damien Chazelle",
    year: 2016,
    cast: "Ryan Gosling, Emma Stone",
    synopsis: "Un músico y una aspirante a actriz luchan por alcanzar sus sueños en Los Ángeles mientras se enamoran."
  },
  {
    title: "Rocketman",
    image: rocketman,
    director: "Dexter Fletcher",
    year: 2019,
    cast: "Taron Egerton, Jamie Bell, Richard Madden",
    synopsis: "La biografía musical de Elton John, desde sus inicios hasta la fama mundial."
  },
  {
    title: "School of Rock",
    image: schoolofrock,
    director: "Richard Linklater",
    year: 2003,
    cast: "Jack Black, Joan Cusack",
    synopsis: "Un músico desempleado se hace pasar por profesor y enseña rock a un grupo de niños."
  },
  {
    title: "Tár",
    image: tar,
    director: "Todd Field",
    year: 2022,
    cast: "Cate Blanchett, Noémie Merlant",
    synopsis: "La historia de una directora de orquesta que enfrenta desafíos profesionales y personales."
  },
  {
    title: "The Greatest Showman",
    image: thegreatestshowman,
    director: "Michael Gracey",
    year: 2017,
    cast: "Hugh Jackman, Zac Efron, Michelle Williams",
    synopsis: "La vida de P. T. Barnum y la creación de un espectáculo que capturó la imaginación del mundo."
  },
  {
    title: "Whiplash",
    image: whiplash,
    director: "Damien Chazelle",
    year: 2014,
    cast: "Miles Teller, J.K. Simmons",
    synopsis: "Un joven baterista busca la perfección bajo la exigente tutela de su implacable instructor."
  },
];

// ⭐⭐⭐⭐⭐ SVGs
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient_melomana">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient_melomana)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);
  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Melomana() {
  useEffect(() => window.scrollTo(0, 0), []);

  // STORAGE separado
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMovies_Melomana") || "{}")
  );

  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatings_Melomana") || "{}")
  );

  const toggleSeen = (title) => {
    const updated = { ...seen, [title]: !seen[title] };
    setSeen(updated);
    localStorage.setItem("seenMovies_Melomana", JSON.stringify(updated));

    if (!updated[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatings_Melomana", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatings_Melomana", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Melómana</h1>
      <p>
        Gran conocedora de muchas de las mejores bandas de la historia y de la actualidad,
        con un gusto musical exquisito. Fanática del pop, pero sin encasillarse: multifacética.
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = Boolean(seen[movie.title]);
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className={`movie-card ${isSeen ? "movie-card-seen" : ""}`}>
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    type="button"
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Melomana;

